<div class="slds-notify_container">
  <ngl-alert class="slds-m-top_small" variant="warning">{{ broadcastMessage }}</ngl-alert>
</div>
